<template>
  <div class="user-center container">
    <CustomerService></CustomerService>
    <div class="user-box">
      <div class="user-avatar avatar">
        <el-upload class="avatar-uploader" action="" :auto-upload="false" accept="image/jpg,image/jpeg,image/png" :show-file-list="false" :on-change="handleAvatarChange">
          <el-avatar :size="220" :src="avatar" v-if="avatar && avatar != ''"></el-avatar>
          <el-avatar :size="220" :src="userInfo.avatar" v-else><img src="../assets/pic/avatar.png" /></el-avatar>
        </el-upload>
      </div>
      <div class="name">
        <VueCountryFlag :value="user.nationality" v-if="user && user.nationality"></VueCountryFlag>
        {{ user && user.firstName ? `${user.firstName} ${user.lastName}` : userInfo.username }}
      </div>
      <ul class="user-list">
        <li @click="dialogVisible = true"><img class="user-icon" src="../assets/images/icon-user-circle.svg" width="40" /></li>
        <li @click="favoritesVisible = true"><img class="user-icon" src="../assets/images/icon-fav-circle.svg" width="40" /></li>
      </ul>
    </div>

    <Message />

    <div class="order-list">
      <el-collapse accordion v-model="activeNames" v-if="orderList.length > 0">
        <el-collapse-item v-for="(item, index) in orderList" :key="index" :name="index">
          <template slot="title">
            <div class="collapse-item-header">
              <div class="item-meta">
                <div class="item-time">
                  <div v-if="item.isCurrentStay">
                    {{ ts('CURRENT STAY')['CURRENT STAY'] }}<template v-if="item.st">：{{ item.st }} - {{ item.ed }}</template>
                  </div>
                  <div v-else>
                    {{ ts('PREVIOUS STAY')['PREVIOUS STAY'] }}<template v-if="item.st">：{{ item.st }} - {{ item.ed }}</template>
                  </div>
                </div>
                <div class="hotel-name">{{ item.hotelName }}</div>
              </div>
              <a class="pay-link" v-if="!item.isPay"> {{ ts('UNPAID ORDER')['UNPAID ORDER'] }} </a>
            </div>
          </template>
          <div class="item" v-for="order in item.apiOrderVos" :key="order.id">
            <div class="order-content" :style="`background-image: url('${order.backGroundImg}')`">
              <div class="hotel-logo">
                <img :src="order.logo ? order.logo : '../assets/pic/login-logo.png'" width="185" />
              </div>
              <div class="order-detail">
                <div class="title">{{ ts('RESERVATION DETAIL')['RESERVATION DETAIL'] }}</div>
                <ul>
                  <li>
                    <div class="label">{{ ts('Order Number')['Order Number'] }}</div>
                    <div class="value">{{ order.orderId }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Name')['Name'] }}</div>
                    <div class="value">{{ order.customerName }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Check-in Time')['Check-in Time'] }}</div>
                    <div class="value">{{ order.checkInTime }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Check-out Time')['Check-out Time'] }}</div>
                    <div class="value">{{ order.checkOutTime }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Length Of Stay')['Length Of Stay'] }}</div>
                    <div class="value">{{ getDays(order) }} {{ ts('Days')['Days'] }}</div>
                  </li>
                  <li v-if="order.roomTypeName_translate">
                    <div class="label">{{ ts('Room Type')['Room Type'] }}</div>
                    <div class="value">{{ order.roomTypeName_translate }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Room Number')['Room Number'] }}</div>
                    <div class="value">{{ order.roomNum }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Number Of Guest')['Number Of Guest'] }}</div>
                    <div class="value">{{ order.guest }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Payment Status')['Payment Status'] }}</div>
                    <div class="value">{{ order.paymentStatus_translate }}</div>
                  </li>
                  <li>
                    <div class="label">{{ ts('Room Status')['Room Status'] }}</div>
                    <div class="value">{{ order.roomStatus_translate }}</div>
                  </li>
                  <li class="paid-now" @click="toPay(order, 'HOTEL_ORDER')" v-if="!order.isPay">
                    {{ ts('PAID NOW')['PAID NOW'] }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="order-footer">
              <div class="btns">
                <div class="btn btn-red" :class="{ 'btn-disabled': !order.canCancel }" @click="order.canCancel && showCancel(order, 'hotel')">{{ ts('CANCEL')['CANCEL'] }}</div>
                <div class="btn btn-theme2" @click="handleCheck(order)">{{ ts('CHECK IN/OUT')['CHECK IN/OUT'] }}</div>
                <div class="btn btn-theme2" @click="handlePassword(order)">{{ ts('PASSWORD')['PASSWORD'] }}</div>
                <div class="btn btn-theme2" :class="{ 'btn-disabled': !order.receiptLink }" @click="order.receiptLink && handleReceipt(order)">{{ ts('RECEIPT')['RECEIPT'] }}</div>
                <div class="btn btn-theme2" :class="{ 'btn-disabled': productBtnDisabled(item.pmsProductInfoVos, 1) }" @click="!productBtnDisabled(item.pmsProductInfoVos, 1) && showProduct(1)">{{ ts('PRODUCT')['PRODUCT'] }}</div>
                <div class="btn btn-theme2" :class="{ 'btn-disabled': productBtnDisabled(item.pmsProductInfoVos, 2) }" @click="!productBtnDisabled(item.pmsProductInfoVos, 2) && showProduct(2)">{{ ts('ACTIVITY')['ACTIVITY'] }}</div>
                <div class="btn btn-theme2" :class="{ 'btn-disabled': productBtnDisabled(item.pmsProductInfoVos, 3) }" @click="!productBtnDisabled(item.pmsProductInfoVos, 3) && showProduct(3)">{{ ts('SERVICE')['SERVICE'] }}</div>
                <div class="btn btn-theme" @click="handleStay(order)">{{ ts('STAY-EXTEND')['STAY-EXTEND'] }}</div>
              </div>
            </div>
          </div>
          <!-- 酒店产品信息筛选展示 -->
          <template v-for="order in item.pmsProductInfoVos">
            <div class="item" v-if="showProductType && showProductType == order.productType" :key="order.id">
              <div class="order-content" :style="`background-image: url('${order.backGroundImg}')`">
                <div class="order-detail">
                  <div class="title">{{ ts(`${getProductTypeText(order.productType)} RESERVATION DETAIL`)[`${getProductTypeText(order.productType)} RESERVATION DETAIL`] }}</div>
                  <ul>
                    <li>
                      <div class="label">{{ ts('Order Number')['Order Number'] }}</div>
                      <div class="value">{{ order.groupOrderId }}</div>
                    </li>
                    <li v-if="order.name_translate">
                      <div class="label">{{ ts('Activity Name')['Activity Name'] }}</div>
                      <div class="value">{{ order.name_translate }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Name')['Name'] }}</div>
                      <div class="value">{{ order.customerName }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Reservation Time')['Reservation Time'] }}</div>
                      <div class="value">{{ order.reservationTime }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Quantity')['Quantity'] }}</div>
                      <div class="value">{{ order.quantity }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Total Cost')['Total Cost'] }}</div>
                      <div class="value">{{ order.total }}</div>
                    </li>
                    <li class="paid-now" @click="toPay(order, 'PRODUCT_ORDER')" v-if="!order.isPay">
                      {{ ts('PAID NOW')['PAID NOW'] }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="order-footer">
                <div class="btns">
                  <div class="btn btn-red" :class="{ 'btn-disabled': !order.canCancel }" @click="order.canCancel && showCancel(order, 'product')">{{ ts('CANCEL')['CANCEL'] }}</div>
                  <div class="btn btn-theme2" :class="{ 'btn-disabled': !order.receiptLink }" @click="order.receiptLink && handleReceipt(order)">{{ ts('RECEIPT')['RECEIPT'] }}</div>
                  <div class="btn btn-theme" @click="toProduct(order)">{{ ts('RE-ORDER')['RE-ORDER'] }}</div>
                </div>
              </div>
            </div>
          </template>
          <!-- 产品信息 -->
          <template v-if="item.apiOrderVos.length === 0 && item.pmsProductInfoVos.length > 0">
            <div class="item" v-for="order in item.pmsProductInfoVos" :key="order.id">
              <div class="order-content" :style="`background-image: url('${order.backGroundImg}')`">
                <div class="order-detail">
                  <div class="title">{{ ts(`${getProductTypeText(order.productType)} RESERVATION DETAIL`)[`${getProductTypeText(order.productType)} RESERVATION DETAIL`] }}</div>
                  <ul>
                    <li>
                      <div class="label">{{ ts('Order Number')['Order Number'] }}</div>
                      <div class="value">{{ order.groupOrderId }}</div>
                    </li>
                    <li v-if="order.name_translate">
                      <div class="label">{{ ts('Activity Name')['Activity Name'] }}</div>
                      <div class="value">{{ order.name_translate }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Name')['Name'] }}</div>
                      <div class="value">{{ order.customerName }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Reservation Time')['Reservation Time'] }}</div>
                      <div class="value">{{ order.reservationTime }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Quantity')['Quantity'] }}</div>
                      <div class="value">{{ order.quantity }}</div>
                    </li>
                    <li>
                      <div class="label">{{ ts('Total Cost')['Total Cost'] }}</div>
                      <div class="value">{{ order.total }}</div>
                    </li>
                    <li class="paid-now" @click="toPay(order, 'PRODUCT_ORDER')" v-if="!order.isPay">
                      {{ ts('PAID NOW')['PAID NOW'] }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="order-footer">
                <div class="btns">
                  <div class="btn btn-red" :class="{ 'btn-disabled': !order.canCancel }" @click="order.canCancel && showCancel(order, 'product')">{{ ts('CANCEL')['CANCEL'] }}</div>
                  <div class="btn btn-theme2" :class="{ 'btn-disabled': !order.receiptLink }" @click="order.receiptLink && handleReceipt(order)">{{ ts('RECEIPT')['RECEIPT'] }}</div>
                  <div class="btn btn-theme" @click="toProduct(order)">{{ ts('RE-ORDER')['RE-ORDER'] }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-collapse-item>
      </el-collapse>
      <div v-else class="empty">{{ ts('No Reservation Data')['No Reservation Data'] }}</div>
      <div class="view-more" v-if="isMore" @click="showMoreOrder">
        <a>{{ ts('MORE')['MORE'] }} <img src="../assets/images/icon-more.svg" width="18" /> </a>
      </div>
    </div>

    <!-- 个人资料 -->
    <el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="1000px">
      <div class="page-detail user-info">
        <el-divider>{{ ts('Personal Information')['Personal Information'] }}</el-divider>
        <el-form :model="userForm" ref="userForm" label-position="top" label-width="200px" class="user-form">
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="ts('First name :')['First name :']" prop="firstName" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <el-input v-model="userForm.firstName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="ts('Last name :')['Last name :']" prop="lastName" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <el-input v-model="userForm.lastName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="ts('Nationality :')['Nationality :']" prop="nationality" class="nationality" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <vue-country-intl type="country" placeholder="" v-model="userForm.nationality"></vue-country-intl>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="ts('Contact Number :')['Contact Number :']" prop="contactNumber" class="phone" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <vue-country-intl type="phone" placeholder="" :onlyValue="false" :showLabelImg="true" v-model="userForm.areaCode"></vue-country-intl>
                <el-input v-model="userForm.contactNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="80">
            <el-col :span="24">
              <el-form-item :label="ts('Residential address :')['Residential address :']" prop="residentialAddress" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <el-input v-model="userForm.residentialAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="ts('Occuption :')['Occuption :']" prop="occuption" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <el-select v-model="userForm.occuption" :placeholder="ts('Enter your occupation')['Enter your occupation']">
                  <el-option v-for="item in occupationList" :key="item.value" :label="item.text_translate" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="ts('Personal ldentity Document Type :')['Personal ldentity Document Type :']" prop="identityType">
                <el-select v-model="userForm.identityType" :placeholder="ts('Enter the type of personal ID')['Enter the type of personal ID']">
                  <el-option v-for="item in identityTypeList" :key="item.value" :label="item.text_translate" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="80">
            <el-col :span="12" :offset="6">
              <div style="margin:0 auto 20px;width: 320px;" v-if="uplodaProgress">
                <el-progress :percentage="uplodaProgress"></el-progress>
              </div>
              
              <el-form-item class="idcard-uploader" prop="idNumberUrl">
                <el-upload action="" :auto-upload="false" accept="image/jpg,image/jpeg,image/png" :show-file-list="false" :on-change="handleIdNumberUrlChange">
                  <img :src="userForm.idNumberUrl" alt="" v-if="userForm.idNumberUrl && userForm.idNumberUrl != ''" />
                  <img src="../assets/images/upload-card.png" v-else />
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-submit">
            <el-button type="primary" :loading="btnLoading" class="btn btn-theme" @click="submitForm('userForm')">{{ ts('DONE')['DONE'] }}</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- password -->
    <el-dialog :visible.sync="passwordVisible" width="1000px">
      <div class="page-detail" v-if="passwordInfo">
        <el-divider>{{ ts('Room Lock password')['Room Lock password'] }}</el-divider>
        <ul class="password-list">
          <li>
            <div class="label">{{ ts('Room number')['Room number'] }} :</div>
            <div class="value">{{ passwordInfo.roomNum }}</div>
          </li>
          <li v-if="passwordInfo.roomPwd">
            <div class="label">{{ ts('Lock Pin')['Lock Pin'] }} :</div>
            <div class="value">
              {{ passwordInfo.roomPwd }}
              <div class="btn btn-theme" @click="doCopy(passwordInfo.roomPwd)">{{ ts('Copy')['Copy'] }}</div>
            </div>
          </li>
        </ul>
        <el-divider>{{ ts('Wifi password')['Wifi password'] }}</el-divider>
        <ul class="password-list">
          <li v-if="passwordInfo.wifiName">
            <div class="label">{{ ts('Network name')['Network name'] }} :</div>
            <div class="value">{{ passwordInfo.wifiName }}</div>
          </li>
          <li v-if="passwordInfo.wifiPassword">
            <div class="label">{{ ts('Password')['Password'] }} :</div>
            <div class="value">
              {{ passwordInfo.wifiPassword }}
              <div class="btn btn-theme" @click="doCopy(passwordInfo.wifiPassword)">{{ ts('Copy')['Copy'] }}</div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>

    <!-- orderCancel -->
    <el-dialog :visible.sync="cancelVisible" width="1000px">
      <div class="page-detail">
        <div class="order-cancel">
          <div class="tips">{{ ts('Please review the cancellation policy below and contact the staff if you have any question before cancellation.')['Please review the cancellation policy below and contact the staff if you have any question before cancellation.'] }}</div>
          <div class="title">{{ ts('Are you sure to cancel this reservation?')['Are you sure to cancel this reservation?'] }}</div>
          <el-button type="danger" round @click="cancelOrder">{{ ts('CONFIRM TO CANCEL')['CONFIRM TO CANCEL'] }}</el-button>
        </div>
        <CancellationPolicy :detail="curOrder" />
      </div>
    </el-dialog>

    <!-- Favorites -->
    <el-dialog :visible.sync="favoritesVisible" class="user-fav" width="1080px">
      <Favorites />
    </el-dialog>

    <!-- 续房 -->
    <el-dialog :visible.sync="stayVisible" class="stay-extend" width="1000px">
      <StayExtend :order="curOrder" :key="stayExtendKey" />
    </el-dialog>

    <!-- 支付方式 -->
    <el-dialog :visible.sync="payMethodVisible" width="1000px">
      <PayMethod :orderType="curOrderType" :orderId="curOrder.orderId" @confirm="createPayment" />
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction, uploadAction } from '@/api/manage'
import { USER_INFO } from '@/store/mutation-types'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Message from '@/components/Message.vue'
import StayExtend from '@/components/StayExtend.vue'
import Favorites from '@/components/Favorites.vue'
import CancellationPolicy from '@/components/CancellationPolicy.vue'
import CustomerService from '@/components/CustomerService.vue'
import PayMethod from '@/components/PayMethod.vue'

export default {
  name: 'User',
  mixins: [LanguagePackage],
  components: {
    Message,
    StayExtend,
    Favorites,
    CancellationPolicy,
    CustomerService,
    PayMethod,
  },
  data() {
    return {
      page: 1,
      activeNames: ['1'],
      orderList: [],
      userInfo: this.$ls.get(USER_INFO),
      dialogVisible: false,
      userForm: {
        areaCode: null,
        contactNumber: null,
        firstName: null,
        lastName: null,
        nationality: null,
        userId: null,
        occuption: '',
        identityType: '',
        residentialAddress: '',
        idNumberUrl: '',
      },
      occupationList: [],
      identityTypeList: [],
      btnLoading: false,
      passwordInfo: null,
      passwordVisible: false,
      avatar: null,
      user: null,
      cancelVisible: false,
      curOrder: {},
      cancelType: null,
      favoritesVisible: false,
      stayVisible: false,
      showProductType: null,

      isMore: false,
      payMethodVisible: false,
      curOrderType: null,
      stayExtendKey: new Date().getTime(),
      uplodaProgress: null,
    }
  },
  created() {
    this.page = 1
    this.getList()
    this.getUserInfo()
    this.getOccupationList()
    this.getIdentityTypeList()
  },
  methods: {
    // 订单列表
    getList() {
      getAction(`/user/api/orderList?page=${this.page}`).then((res) => {
        if (res.result.length >= 10) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        if (res.result.length > 0) {
          this.orderList.push(...res.result)
        }
      })
    },
    showMoreOrder() {
      this.page = this.page + 1
      this.getList()
    },
    // 职业列表
    getOccupationList() {
      getAction('/pc/home/getDictItems/occupation').then((res) => {
        this.occupationList = res.result
        console.log(res)
      })
    },
    // 身份类别列表
    getIdentityTypeList() {
      getAction('/pc/home/getDictItems/identity_type').then((res) => {
        this.identityTypeList = res.result
      })
    },
    // 获取用户信息
    getUserInfo() {
      getAction(`/pc/home/qryPersonalInfo`).then((res) => {
        if (res.result && res.result.contactNumber) {
          this.user = res.result
          const { areaCode, contactNumber, firstName, lastName, nationality, userId, occuption, residentialAddress, identityType, idNumberUrl } = res.result
          this.userForm = { areaCode, contactNumber, firstName, lastName, nationality, userId, occuption, residentialAddress, identityType, idNumberUrl }
        } else {
          // 个人资料未填写时，弹出弹窗
          this.dialogVisible = true
        }
      })
      getAction(`/pc/home/qryAvatar`).then((res) => {
        this.avatar = res.result
      })
    },
    // 入住天数
    getDays(order) {
      let days = 1
      days = this.$dayjs(order.checkOutTime).startOf('day').diff(this.$dayjs(order.checkInTime).startOf('day'), 'day')
      return days
    },
    // 完善个人资料
    submitForm(formName) {
      this.btnLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postAction(`/pc/home/personalRegistration`, this.userForm).then((res) => {
            this.btnLoading = false
            this.dialogVisible = false
            this.$router.push('/')
          })
        } else {
          this.btnLoading = false
          return false
        }
      })
    },
    // 复制
    doCopy(message) {
      this.$copyText(message).then(
        (e) => {
          this.$message({
            message: this.translate('Copied'),
            type: 'success',
          })
          console.log(e)
        },
        (e) => {
          this.$message.error(this.translate('Can not copy'))
          console.log(e)
        }
      )
    },
    // 上传头像
    handleAvatarChange(file) {
      const success = this.beforeAvatarUpload(file.raw)
      if (success) {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('biz', 'temp')
        uploadAction('/sys/common/upload', formData).then((res) => {
          if (res.success) {
            this.avatar = res.message
            this.changeAvatar(res.message)
          }
        })
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error(this.translate('The file format is not correct!'))
      }
      if (!isLt2M) {
        this.$message.error(this.translate('Image size cannot exceed 2MB!'))
      }
      return isJPG
    },
    changeAvatar(avatar) {
      postAction(`/pc/home/modifyAvatar`, { avatar }).then((res) => {})
    },
    // 订单取消提示
    showCancel(order, type) {
      this.curOrder = order
      this.cancelVisible = true
      this.cancelType = type
    },
    // 订单取消
    cancelOrder() {
      let url = `/user/api/productCancel`
      if (this.cancelType == 'hotel') {
        url = `/user/api/orderCancel`
      }
      getAction(url, { orderId: this.curOrder.orderId }).then((res) => {
        if(res.success){
          this.$message({
            message: this.translate('Canceled'),
            type: 'success',
          })
          this.orderList = [];
          this.page = 1
          this.getList()
        }
      })
    },
    handleCheck(order) {
      window.open(order.stepFormUrl, '_blank')
    },
    handlePassword(order) {
      getAction(`/user/api/roomInfo`, { id: order.id }).then((res) => {
        this.passwordInfo = res.result
        this.passwordInfo.roomNum = order.roomNum
        this.passwordVisible = true
      })
    },
    handleReceipt(order) {
      window.open(order.receiptLink, '_blank')
    },
    // 续房
    handleStay(order) {
      this.stayExtendKey = new Date().getTime()
      this.curOrder = order
      this.stayVisible = true
    },
    toProduct(order) {
      this.$router.push(`/product/${order.pageId}?type=${order.productType}`)
    },
    productBtnDisabled(list, type) {
      // 判断是否含有该类型订单
      let disabled = true
      const index = list.findIndex((x) => x.productType == type)
      if (index > -1) {
        disabled = false
      }
      return disabled
    },
    showProduct(type) {
      console.log(type)
      if (type == this.showProductType) {
        this.showProductType = null
      } else {
        this.showProductType = type
      }
    },
    getProductTypeText(productType) {
      let text = ''
      // productType: 1 商品 2 活动 3 服务
      if (productType == '1') {
        text = 'Product'
      }

      if (productType == '2') {
        text = 'Activity'
      }

      if (productType == '3') {
        text = 'Service'
      }

      return text
    },
    // 上传证件照
    handleIdNumberUrlChange(file) {
      console.log(file)
      const success = this.beforeIdNumberUrlUpload(file.raw)
      if (success) {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('biz', 'temp')
        const onUploadProgress = (progress) => {
          console.log(progress)
          this.uplodaProgress = Math.floor((progress.loaded / progress.total) * 100);
        };
        uploadAction('/sys/common/upload', formData, onUploadProgress).then((res) => {
          if (res.success) {
            this.userForm.idNumberUrl = res.message
          }
        })
      }
    },
    beforeIdNumberUrlUpload(file) {
      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message(this.translate('The file format is not correct!'))
      }
      if (!isLt2M) {
        this.$message(this.translate('Image size cannot exceed 2MB!'))
      }
      return isJPG
    },
    // 支付
    toPay(order, type) {
      this.curOrder = order
      this.curOrderType = type
      this.payMethodVisible = true
    },
    // 创建订单支付
    createPayment(platForm) {
      this.$store.dispatch('createPayment', {
        orderType: this.curOrderType,
        groupId: this.curOrder.orderId, // 订单Id
        hotelId: this.curOrder.hotelId, // 酒店Id
        platForm, // Stripe , Paypay
      })
    },
  },
}
</script>
